import { Input } from "@/components/ui/input";
import { ParameterSelectProps } from ".";
import Combobox from "@/components/custom/Combobox";
import { Eye, EyeOff, RefreshCcw } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

export function ParameterSelect({
    parameterData,
    value,
    onChange,
    onCreate
}: Readonly<ParameterSelectProps>) {
    const [showValue, setShowValue] = useState(!parameterData?.settings?.isPrivate);
    const renderCombobox = parameterData?.options !== undefined && parameterData?.options !== null && parameterData?.options?.length !== 0;
    return (
        <div className="grid gap-1 grid-cols-[1fr_auto] items-center">
            <div className="min-w-0">
                {(() => {
                    if (
                        !renderCombobox
                    ) {
                        return <Input value={value ?? undefined} onChange={(e) => onChange(e.target.value)} type={showValue ? "text" : "password"} />;
                    }
                    return (
                        <Combobox
                            triggerLabel={parameterData.name}
                            mode="single"
                            selectedValue={value ?? ""}
                            setSelectedValue={onChange}
                            inDialog
                            onCreate={onCreate}
                            renderSelectedValue={showValue?undefined:(selectedValue, items)=>items.find(i=>i.value===selectedValue)?.label.replaceAll(/./g, '•')}
                            items={parameterData?.options?.map((option) => ({ label: option.key, value: option.value })) ?? []}
                        />
                    )
                })()}
            </div>
            {parameterData?.settings?.isPrivate && (
                <Button type="button" className="grid w-10 aspect-square place-items-center" variant='outline' onClick={() => setShowValue(prev => !prev)}  >
                    {showValue
                        ? <Eye className="" size={18} />
                        : <EyeOff className="" size={18} />
                    }
                </Button>
            )}
            {renderCombobox && (
                <Button type="button" className="grid w-10 aspect-square place-items-center" variant='outline' onClick={() => onChange(null)}  >
                    <RefreshCcw size={18}/>
                </Button>
            )}
        </div>
    )
}